import ProductsHero from './components/ProductsHero';
import SharedTrustBar from '../../components/feature/SharedTrustBar';
import ProductsGrid from './components/ProductsGrid';
import MidCTA from '../../components/feature/MidCTA';
import SharedAIBlock from '../../components/feature/SharedAIBlock';
import SharedHowItWorks from '../../components/feature/SharedHowItWorks';
import SharedWhyChooseUs from '../../components/feature/SharedWhyChooseUs';
import ProductsGlobal from './components/ProductsGlobal';
import SharedTestimonials from '../../components/feature/SharedTestimonials';
import SharedFAQ from '../../components/feature/SharedFAQ';
import SharedFinalCTA from '../../components/feature/SharedFinalCTA';
import { productsAIItems, repairSteps, whyReasons } from '../../mocks/shared-sections';
import { productFaqs } from '../../mocks/faqs';

export default function ProductsPage() {
  return (
    <main className="min-h-screen">
      {/* 1. Hero */}
      <ProductsHero />
      {/* 2. Trust Bar */}
      <SharedTrustBar />
      {/* 3. Product Section */}
      <ProductsGrid />
      {/* Mid CTA */}
      <MidCTA
        headline="Not Sure Which Kit? We'll Help."
        sub="The Universal Kit works on any board type — epoxy or poly. Start there."
        btnLabel="Shop Universal Kit"
        btnTo="/products/universal-sunpowered-kit"
        urgency="Best Seller · 4.9★ · 1,284 Reviews"
        variant="teal"
      />
      {/* 4. AI Answer Block */}
      <SharedAIBlock
        title="Choosing the Right Repair Kit"
        items={productsAIItems}
      />
      {/* 5. How It Works */}
      <SharedHowItWorks
        title="How It Works"
        subtitle="Every PHIX Doctor kit follows the same simple repair process — done in minutes."
        steps={repairSteps}
        bgClass="bg-[#F5EFE6]"
      />
      {/* 6. Why Choose Us */}
      <SharedWhyChooseUs
        reasons={whyReasons}
        showComparison={true}
        bgClass="bg-white"
      />
      {/* Mid CTA */}
      <MidCTA
        headline="Fix Your Board Before Your Next Session"
        sub="Orders placed before noon ship the same day."
        btnLabel="Shop All Products"
        urgency="Free shipping on orders over $50"
        variant="orange"
      />
      {/* 7. Global Section */}
      <ProductsGlobal />
      {/* 8. Testimonials */}
      <SharedTestimonials />
      {/* 9. FAQ */}
      <SharedFAQ
        faqs={productFaqs}
        title="Product Questions"
        subtitle="Common questions about PHIX Doctor repair kits and which kit is right for you."
        bgClass="bg-[#F5EFE6]"
      />
      {/* 10. Final CTA */}
      <SharedFinalCTA
        headline="The Right Kit for Your Board."
        headlineAccent="Ready to Ship Today."
        primaryLabel="Shop All Kits"
        secondaryLabel="Find a Store"
        secondaryTo="/where-to-buy"
        urgency="Don't let a ding cancel your next session."
      />
    </main>
  );
}
